// EXIF stores GPS as three rationals (degrees, minutes, seconds) plus a
// hemisphere ref. exif-reader (backend fileupload) exposes this as
// image.exif.gps — nothing in the upload pipeline strips it.

function dmsToDecimal(dms, ref, negativeRef) {
    if (!Array.isArray(dms) || dms.length < 3) {
        return null;
    }
    const [degrees, minutes, seconds] = dms.map(Number);
    if (![degrees, minutes, seconds].every(Number.isFinite)) {
        return null;
    }
    const decimal = degrees + (minutes / 60) + (seconds / 3600);
    return String(ref).toUpperCase() === negativeRef ? -decimal : decimal;
}

export function exifGpsToDecimal(gps) {
    if (!gps) {
        return null;
    }
    const latitude = dmsToDecimal(gps.GPSLatitude, gps.GPSLatitudeRef, 'S');
    const longitude = dmsToDecimal(gps.GPSLongitude, gps.GPSLongitudeRef, 'W');
    if (latitude === null || longitude === null) {
        return null;
    }
    return { latitude, longitude };
}

function finitePair(latitude, longitude) {
    const lat = Number(latitude);
    const lon = Number(longitude);
    if (latitude === undefined || latitude === null || latitude === ''
        || longitude === undefined || longitude === null || longitude === ''
        || !Number.isFinite(lat) || !Number.isFinite(lon)) {
        return null;
    }
    return { latitude: lat, longitude: lon };
}

// Where a sticker's "my position" comes from, best source first: the photo
// itself (authors often post later, elsewhere), then the browser fix already
// captured by the composer, then the article's stored location.
export function pickOverlayCoordinates({ image, browser, location } = {}) {
    return exifGpsToDecimal(image?.exif?.gps)
        || finitePair(browser?.latitude, browser?.longitude)
        || finitePair(location?.latitude, location?.longitude)
        || null;
}
